import { render, staticRenderFns } from "./SubDataDetail.vue?vue&type=template&id=750aa53c&scoped=true&"
import script from "./SubDataDetail.vue?vue&type=script&lang=js&"
export * from "./SubDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubDataDetail.vue?vue&type=style&index=0&id=750aa53c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750aa53c",
  null
  
)

export default component.exports